export default "__VITE_ASSET__8008ebd1__"